<!-- language selector goes here -->
<nx-link><a (click)="changeLanguage('de')">DE </a></nx-link>
<span class="spacer"></span>
<nx-link><a (click)="changeLanguage('fr')">FR </a></nx-link>
<span class="spacer"></span>
<nx-link><a (click)="changeLanguage('it')">IT</a></nx-link>